/* eslint-disable jsx-a11y/media-has-caption */
import { ArrowForwardIosRounded, Close, FolderOpenRounded } from '@mui/icons-material'
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Link,
  Stack,
  Typography,
} from '@mui/material'
import React, { useMemo, useState } from 'react'

import { useConversionReport } from 'hooks/useConversionReport'
import { ReactComponent as MetaAdsIcon } from './meta_anuncios_ads.svg'
import CoverImg from './Imagem.svg'
import Loader from 'components/Loader'

const DefaultCover = (
  <Stack
    height="22rem"
    minWidth="22rem"
    display="flex"
    flex={1}
    justifyContent="center"
    alignItems="center"
  >
    <img
      src={CoverImg}
      alt="imagem"
      style={{
        width: 'fit-content',
      }}
    />
  </Stack>
)
const renderMedia = ({ mediaType, mediaUrl, displayMediaCover = false }) => {

  if (!mediaType || !mediaUrl || displayMediaCover) {
    return DefaultCover
  }

  switch (mediaType.toLowerCase()) {
    case 'image':
      return (
        <Stack
          height="23rem"
          minWidth="26rem"
          display="flex"
          flex={1}
          bgcolor="#E3F2FC"
          justifyContent="center"
          alignItems="center"
        >
          <img
            src={mediaUrl}
            alt="imagem do anúncio"
            style={{
              width: 'fit-content',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </Stack>
      )
    case 'video':
      return (
        <Stack
          maxHeight="23rem"
          minWidth="26rem"
          display="flex"
          flex={1}
          bgcolor="#E3F2FC"
          justifyContent="center"
          alignItems="center"
        >
          <Loader id="loader" />
          <iframe
            title="frame-video-embedding"
            src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(
              'https://www.facebook.com/HiPlatformBR/videos/1363873197955429/',
            )}&height=370`}
            onLoad={() => {
              document.getElementById('loader').style.display = 'none';
            }}
            style={{
              border: 'none',
              overflow: 'hidden',
              width: '100%',
              height: '100%',
            }}
            scrolling="no"
            frameBorder="0"
            allowfullscreen="true"
          />
        </Stack>
      )
    default:
      return DefaultCover
  }
}

function AdsPreview() {
  const [mediaNotFound, setMediaNotFound] = useState(false)
  const { state, actions } = useConversionReport()
  const { adsPreview } = state
  const { unsetAdsPreview } = actions

  /**
   * @typedef PreviewProps
   * @property {boolean} open
   * @property {object} advertisement
   * @property {boolean} advertisement.status
   * @property {boolean} advertisement.campaignStatus
   * @property {string} advertisement.campaignName
   * @property {string} advertisement.name
   * @property {string} advertisement.url
   * @property {string} advertisement.headline
   * @property {string} advertisement.mediaType
   * @property {string} advertisement.imageUrl
   * @property {string} advertisement.body
   */
  /**
   * @type {PreviewProps}
   */
  const { open, advertisement } = adsPreview

  const onClose = () => {
    setMediaNotFound(false)
    unsetAdsPreview()
  }

  const displayMediaCover = useMemo(() => {
    if(!advertisement?.status || !advertisement?.campaignStatus) return true
    else return false
  }, [advertisement])

  useMemo(() => {   
    if (!!advertisement?.imageUrl && advertisement?.mediaType === 'image') {
      fetch(advertisement.imageUrl)
      .then(response => {
        if (response.status !== 200) {
          throw new Error('Image not found')
        }
        response.json()
      })
      .catch((error) => {
        console.error(error)
        setMediaNotFound(true)
      })
    }
  }, [advertisement])

  if (!open) return null

  return (
    <Dialog open={open} fullWidth maxWidth="lg">
      <Stack direction="row" alignItems="center">
        <DialogTitle data-testid="step-title" gap="1rem" display="flex" flexDirection="row" alignItems="center">
          <Box minWidth="18rem" gap="1rem" display="flex" flexDirection="row" alignItems="center">
            <Stack flexDirection="row" alignItems="center" gap=".5rem">
              <FolderOpenRounded color="disabled" />
              <Typography variant="body1" color="#9E9E9E" fontWeight="500" fontSize="1.1rem">
                Campanha: {advertisement.campaignName}
              </Typography>
              {/* <Typography variant="caption" textTransform="uppercase" color="text.secondary">
                  ID - 202345687
                </Typography> */}
            </Stack>
          </Box>
          <ArrowForwardIosRounded fontSize="small" color="disabled" />
          <Typography display="flex" alignItems="center" gap="0.2rem" color="text.secondary" fontWeight="bold">
            <MetaAdsIcon />
            Anúncio: {advertisement.name}
          </Typography>
        </DialogTitle>
        <IconButton
          data-testid="close-dialog-btn-action"
          aria-label="Fechar"
          sx={{ ml: 'auto', mr: 1.5 }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
      </Stack>
      <DialogContent data-testid="content-dialog">
        <Typography variant="h4" sx={{ fontSize: '1.3rem', fontWeight: 700 }}>
          Informações do Anúncio
        </Typography>
        <Typography variant="subtitle1" mt=".5rem">
          Veja informações detalhadas sobre os anúncios que converteram os leads de sua campanha. Consulte informações
          essenciais, como título, texto principal, tipo e link, para uma compreensão completa das origens das suas
          conversões.
        </Typography>
        <Stack flexDirection="row" gap="1.5rem" p="1rem">
          <Box flexDirection="column" gap="0.5rem" width="36rem">
            <Stack
              flexDirection="row"
              alignItems="center"
              gap="1rem"
              padding=".5rem"
              borderBottom={1}
              borderColor="divider"
              height="4rem"
            >
              <Typography color="black" textAlign="right" minWidth="8rem" fontWeight="bold" data-testid="title-ads">
                Título:
              </Typography>
              <Typography display="flex">{advertisement.headline}</Typography>
            </Stack>
            <Stack
              flexDirection="row"
              alignItems="center"
              gap="1rem"
              padding=".5rem"
              borderBottom={1}
              borderColor="divider"
              height="4rem"
            >
              <Typography
                color="black"
                textAlign="right"
                minWidth="8rem"
                fontWeight="bold"
                noWrap
                data-testid="main-text"
              >
                Texto principal:
              </Typography>
              <Typography display="flex">{advertisement.body}</Typography>
            </Stack>
            <Stack
              flexDirection="row"
              alignItems="center"
              gap="1rem"
              padding=".5rem" 
              borderBottom={1}
              borderColor="divider"
              height="4rem"
            >
              <Typography color="black" textAlign="right" minWidth="8rem" fontWeight="bold" data-testid="ads-type">
                Tipo:
              </Typography>
              <Typography display="flex" textTransform="capitalize">
                {advertisement.mediaType}
              </Typography>
            </Stack>
            <Stack flexDirection="row" alignItems="center" gap="1rem" padding=".5rem" height="4rem">
              <Typography color="black" textAlign="right" minWidth="8rem" fontWeight="bold">
                Link:
              </Typography>
              <Typography
                display="flex"
                component={Link}
                href={advertisement.url}
                target="_blank"
                sx={{
                  cursor: 'pointer',
                }}
              >
                {advertisement.url}
              </Typography>
            </Stack>
          </Box>
          {renderMedia({
            mediaType: advertisement.mediaType,
            mediaUrl: advertisement.imageUrl,
            displayMediaCover: displayMediaCover || mediaNotFound,
          })}
        </Stack>
        {!advertisement.status || !advertisement.campaignStatus ? (
          <Alert severity="warning" sx={{mt:'.5rem'}}>
            A imagem não está disponível para anúncios inativos ou pertencentes a campanhas desativadas, pausadas ou
            finalizadas. Caso ative a campanha ou anúncio, poderá levar até 24h para reativar.
          </Alert>
        ) : null}
        {advertisement.status && advertisement.campaignStatus && mediaNotFound ? (
          <Alert severity="warning" sx={{mt:'.5rem'}}>
            A Meta expirou a imagem deste anúncio, por isso ela não está sendo exibida. Poderá ser exibida novamente quando novas conversas acontecerem.
          </Alert>
        ) : null}
      </DialogContent>
      <DialogActions
        sx={{
          paddingY: '1rem',
          paddingX: '2.5rem',
          borderTop:1,
          borderColor:"divider"
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          data-testid="return-btn-action"
          sx={{
            backgroundColor: '#00AEEF',
            ':hover': {
              backgroundColor: '#009DEB',
            },
          }}
        >
          Voltar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AdsPreview
